<template><section><h1>Circle 环形进度条</h1>
<p>用于展示操作进度，告知用户当前状态和预期。</p>
<h3>基本调用</h3>
<demo-block>
                <div class="source" slot="source"><ayu-circle :percent="40"><span>项目1</span></ayu-circle>
<ayu-circle :percent="40" status="success"><span>项目2</span></ayu-circle>
<ayu-circle :percent="40" status="info"><span>项目3</span></ayu-circle>
<ayu-circle :percent="40" status="warning"><span>项目4</span></ayu-circle>
<ayu-circle :percent="40" status="danger"><span>项目5</span></ayu-circle>

</div>
                <p>预制了五种颜色，通过<code>status</code>来定义, 分别是<code>primary</code>(默认)、 <code>success</code>、 <code>info</code>、<code>warning</code>、<code>danger</code></p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-circle</span> <span class="hljs-attr">:percent</span>=<span class="hljs-string">"40"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span>&gt;</span>项目1<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ayu-circle</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ayu-circle</span> <span class="hljs-attr">:percent</span>=<span class="hljs-string">"40"</span> <span class="hljs-attr">status</span>=<span class="hljs-string">"success"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span>&gt;</span>项目2<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ayu-circle</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ayu-circle</span> <span class="hljs-attr">:percent</span>=<span class="hljs-string">"40"</span> <span class="hljs-attr">status</span>=<span class="hljs-string">"info"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span>&gt;</span>项目3<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ayu-circle</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ayu-circle</span> <span class="hljs-attr">:percent</span>=<span class="hljs-string">"40"</span> <span class="hljs-attr">status</span>=<span class="hljs-string">"warning"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span>&gt;</span>项目4<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ayu-circle</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ayu-circle</span> <span class="hljs-attr">:percent</span>=<span class="hljs-string">"40"</span> <span class="hljs-attr">status</span>=<span class="hljs-string">"danger"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span>&gt;</span>项目5<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ayu-circle</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3>自定义颜色</h3>
<demo-block>
                <div class="source" slot="source"><ayu-circle :percent="40" color="#12e9e9"><span>项目1</span></ayu-circle>
<ayu-circle :percent="40" color="skyblue"><span>项目1</span></ayu-circle>

</div>
                <p>用过<code>color</code>定义颜色</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-circle</span> <span class="hljs-attr">:percent</span>=<span class="hljs-string">"40"</span> <span class="hljs-attr">color</span>=<span class="hljs-string">"#12e9e9"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span>&gt;</span>项目1<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ayu-circle</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ayu-circle</span> <span class="hljs-attr">:percent</span>=<span class="hljs-string">"40"</span> <span class="hljs-attr">color</span>=<span class="hljs-string">"skyblue"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span>&gt;</span>项目1<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ayu-circle</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3>组合使用</h3>
<demo-block>
                <div class="source" slot="source"><ayu-button icon="minus" @click="decrease"></ayu-button>
<ayu-button icon="plus" @click="increase"></ayu-button>

<ayu-circle :percent="percent"><span>{{percent}}%</span></ayu-circle>


</div>
                
                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"minus"</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"decrease"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">icon</span>=<span class="hljs-string">"plus"</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"increase"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">ayu-circle</span> <span class="hljs-attr">:percent</span>=<span class="hljs-string">"percent"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span>&gt;</span>{{percent}}%<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ayu-circle</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    data() {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">percent</span>: <span class="hljs-number">20</span>
      };
    },
    <span class="hljs-attr">methods</span>: {
      increase() {
        <span class="hljs-keyword">this</span>.percent += <span class="hljs-number">10</span>;
        <span class="hljs-keyword">if</span> (<span class="hljs-keyword">this</span>.percent &gt; <span class="hljs-number">100</span>) {
          <span class="hljs-keyword">this</span>.percent = <span class="hljs-number">100</span>;
        }
      },
      decrease() {
        <span class="hljs-keyword">this</span>.percent -= <span class="hljs-number">10</span>;
        <span class="hljs-keyword">if</span> (<span class="hljs-keyword">this</span>.percent &lt; <span class="hljs-number">0</span>) {
          <span class="hljs-keyword">this</span>.percent = <span class="hljs-number">0</span>;
        }
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>

<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">color</td>
<td style="text-align:left">自定义颜色</td>
<td style="text-align:left">String</td>
<td style="text-align:left">-</td>
<td style="text-align:left">'#3e8ef7'</td>
</tr>
<tr>
<td style="text-align:left">status</td>
<td style="text-align:left">预制状态</td>
<td style="text-align:left">String</td>
<td style="text-align:left">primary/success/info/warning/danger 优先级大于color</td>
<td style="text-align:left">'primary'</td>
</tr>
<tr>
<td style="text-align:left">percent</td>
<td style="text-align:left">显示颜色</td>
<td style="text-align:left">Number</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">stroke-width</td>
<td style="text-align:left">画笔宽度</td>
<td style="text-align:left">Number</td>
<td style="text-align:left">-</td>
<td style="text-align:left">12</td>
</tr>
<tr>
<td style="text-align:left">size</td>
<td style="text-align:left">大小</td>
<td style="text-align:left">Number</td>
<td style="text-align:left">-</td>
<td style="text-align:left">120</td>
</tr>
</tbody>
</table>
</section></template>
<style scoped>
.ayu-circle {
  margin-right: 5px;
}
</style>
<script>
  export default {
    data() {
      return {
        percent: 20
      };
    },
    methods: {
      increase() {
        this.percent += 10;
        if (this.percent > 100) {
          this.percent = 100;
        }
      },
      decrease() {
        this.percent -= 10;
        if (this.percent < 0) {
          this.percent = 0;
        }
      }
    }
  }
</script>